<cw-ci-data-table #integrationPartnerDataTable
  tileTitle="Integration Partners"
  addToolTip="Create a new integration partner"
  refreshToolTip="Reload integration partner list"
  defaultSortField="name"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadIntegrationPartners($event)"
  (addHandler)="addIntegrationPartner($event)"
  (selectHandler)="editIntegrationPartner($event)"
  [items]="integrationPartnerList">

  <cw-ci-table-column columnName="name" columnTitle="Name" sortField="name"></cw-ci-table-column>
  <cw-ci-table-column columnName="partnerKey" columnTitle="Partner Key"></cw-ci-table-column>
  <cw-ci-table-column columnName="plan" columnTitle="Plan" [output]="planTemplate"></cw-ci-table-column>
  <ng-template let-element #planTemplate>{{element.plan.name}} (id: {{element.plan.id}})</ng-template>
  <cw-ci-table-column columnName="applicationUrl" columnTitle="URL"></cw-ci-table-column>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action actionToolTip="Edit the integration partner" svgIcon="cw:action_edit" actionColor="primary" [element]="element" (clickHandler)="editIntegrationPartner($event)"></cw-ci-table-column-action>
  </ng-template>

</cw-ci-data-table>